import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
export function GuaranteeSection() {
  return <Section className="border-y border-white/5 bg-ink-900" data-id="element-95" data-mp="4vryttha25or">
      <Reveal data-id="element-96" data-mp="9ttgqb2yvyyn">
        <div className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-brand/20 bg-ink-850 p-8 text-center sm:p-10" data-id="element-97" data-mp="9tbbwq28ocf4">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-soft" data-id="element-98" data-mp="ercz9n6p6xwe">
            <ShieldCheckIcon className="h-7 w-7 text-brand" data-id="element-99" data-mp="jqg0ewjk4jz3" />
          </span>
          <h2 className="mt-5 font-display text-xl font-bold tracking-tight text-white sm:text-2xl" data-id="element-100" data-mp="nskrbnimf2i1">
            Garantía 30 días — sin preguntas
          </h2>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-gray-400 sm:text-base" data-id="element-101" data-mp="xk71rhn4wxjq">
            Accedé al ebook, recorré el material y usá los bonos. Si sentís que no es para vos, te devolvemos el 100%.
          </p>
        </div>
      </Reveal>
    </Section>;
}